$(document).ready(function () {
  $(".bridgman--sort--container li.cursor ").on("click", function (e) {
    let thisValue = $(this).attr("value");
    let selectBox = $("#SortBy.facet-filters__sort");
    let selectBoxOption = selectBox.children("option");

    $("#SortBy.facet-filters__sort option").each(function () {
      selectBoxOption.removeAttr("selected");
      if (thisValue === $(this).val()) {
        $(this).val(thisValue).attr("selected", "selected");
      }
    });
  });
  $(".price-filter-mobile .js--num, .price-filter-mobile .js--qty-adjuster").click(function (e) {
    e.stopPropagation();
  });
});

function bridgamAddToCart(data) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (cart) {
      var desktop_cart_count = $(".desktop-only .cart-count").text();
      desktop_cart_count = parseInt(desktop_cart_count);

      if ($(".desktop-only .cart-count, #mobileNavBar .cart-count").hasClass("hidden-count")) {
        $(".desktop-only .cart-count, #mobileNavBar .cart-count").removeClass("hidden-count");
      }
      $(".desktop-only .cart-count,#mobileNavBar .cart-count").text(desktop_cart_count + 1);
      $(".ajax-brid-addtocart").find('input[type="submit"]').val("Add To Quote");
    },
    error: function (XMLHttpRequest, textStatus) {},
  };
  jQuery.ajax(params);
}

/****** Announcement bar Count Down ******/
if (document.getElementById("countDownTime")) {
  var times = document.getElementById("countDownTime").getAttribute("data-times");
  var countDownDate = new Date(times).getTime();
  var x = setInterval(function () {
    var now = new Date().getTime();

    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("countDownTime").innerHTML = days + "d : " + hours + "h : " + minutes + "m : " + seconds + "s ";

    if (distance < 0) {
      clearInterval(x);
      document.getElementById("countDownTime").innerHTML = "EXPIRED";
    }
  }, 1000);
}
/****** End Announcement bar Count Down ******/

$(document).ready(function () {
  $(".where_you_hear").on("change", function () {
    $(this).parents("form").find(".bridgman-catalogue_other").addClass("hide");
    $(this).parents("form").find(".bridgman-catalogue_other").removeAttr("required");

    if ($(this).val() == "Other") {
      $(this).parents("form").find(".bridgman-catalogue_other").attr("required", "true");
      $(this).parents("form").find(".bridgman-catalogue_other").removeClass("hide");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var whatsappButtonImg = document.querySelector(".whatsapp-button");
  if (whatsappButtonImg) {
    setTimeout(function () {
      whatsappButtonImg.classList.add("animate");
    }, 100);
  }

  // event listener to close button
  var closeBtn = document.querySelector(".whatsapp-button .close-btn");
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var whatsappButton = e.target.closest(".whatsapp-button");
      if (whatsappButton) {
        whatsappButton.classList.add("close-animate");
        //need this for listening to transition ending
        whatsappButton.addEventListener("transitionend", function () {
          if (whatsappButton.parentNode) {
            whatsappButton.parentNode.removeChild(whatsappButton);
          }
        });
      }
    });
  }
});
